<template>
    <div v-if="view && (view['hydra:next'])" class="text-center mb-3">
        <button type="button" class="btn btn-circle btn-primary btn-lg"
                @click="getPage(view['hydra:next'])"
                :disabled="!view['hydra:next']">
            <font-awesome-icon icon="angle-down" /></button>
    </div>
</template>

<script>
export default {
  props:['view', 'getPage'],
};
</script>



// WEBPACK FOOTER //
// src/components/post/ShowMorePage.vue